const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "This document outlines the terms governing the use of our CCTV and security services. By utilizing our systems and solutions, you agree to adhere to the rules and policies set forth in this agreement."
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: "Our security solutions must be used lawfully and appropriately. Activities such as tampering with equipment, unauthorized monitoring, or engaging in fraudulent activities are prohibited."
    },
    { 
        id: "subscription", 
        title: "3. Subscription Terms", 
        content: "Our services are available through customized packages. Payments must be completed as per agreed timelines. Non-payment may result in service interruptions or account deactivation."
    },
    { 
        id: "user-obligations", 
        title: "4. User Obligations", 
        content: "Users are responsible for safeguarding access credentials to our monitoring systems and ensuring the equipment is used appropriately. Notify us immediately of any unauthorized access or system malfunction."
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: "[CCTV Solutions] shall not be liable for damages caused by misuse of the equipment or interruptions in service due to circumstances beyond our control, as permitted by applicable laws."
    },
    { 
        id: "termination", 
        title: "6. Termination", 
        content: "We reserve the right to terminate services for violation of these Terms or misuse of the security systems. Notifications will be provided when applicable."
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: "All software, hardware designs, and technical content related to our CCTV and security services remain the intellectual property of [CCTV Solutions]. These may not be copied, modified, or redistributed without our consent."
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: "These Terms are governed by the laws of [Jurisdiction]. Any disputes will be resolved under the jurisdiction of the courts in [City/Region]."
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: "For questions regarding these Terms or our services, contact us at support@[cctvsolutions].com or call +[Phone Number]."
    }
];

export default serviceTerms;